import React from 'react'

export default ({ string }) => {
    if (string) {
        return <div className="content"><p className="has-text-danger">{string}</p></div>
    } else {
        return null
    }
}
